import React from "react"
import { BrowserGeolocation } from "../interfaces/browser-geolocation.interface"

export const LocationContext = React.createContext<BrowserGeolocation>({
  isLocationEnabled: false,
})
